// import { Container, Typography } from '@pwskills/rachnaui';
import { useScreenSize } from '@pwskills/rachnaui/hooks';
import { classNames } from '@pwskills/rachnaui/utils';
import React from 'react';

const MetaDataStrip = ({
  meta,
  className = '',
}: {
  meta?: Array<{
    _id: string;
    key: string;
    value: string;
  }>;
  className?: string;
}) => {
  const { width } = useScreenSize();

  // Handle meta array format
  let displayData: Array<{ key: string; value: string; id: string }> = [];

  if (meta && meta.length > 0) {
    // Use meta array format
    displayData = meta.slice(0, 5).map((metaItem) => ({
      key: metaItem?.key,
      value: metaItem?.value,
      id: metaItem?._id,
    }));
  }

  if (displayData.length === 0) {
    return null;
  }

  const getClassNames = (index: number, dataLength: number) => {
    return classNames(
      'flex flex-col min-w-[48%] medium:!min-w-[200px] large:w-[248px] items-center text-center px-8 py-4 medium:!p-0 medium:!pr-4 large:!border-r medium:!border-stroke-300 medium:gap-y-2',
      index % 2 === 0 && width <= 640 ? 'border-r border-stroke-300' : '',
      index !== 2 && width > 640 && width < 1012 ? 'medium:border-r medium:border-stroke-300' : '',
      index !== 3 && width > 640 && width >= 1024 ? 'medium:border-r medium:border-stroke-300' : '',
      index !== 3 && width > 1024 && width <= 1242
        ? 'large:!border-r large:!border-stroke-300'
        : '',
      dataLength - 1 === index ? 'border-r-0 medium:!border-r-0 large:!border-r-0' : ''
    );
  };

  return (
    <section className={classNames(className)}>
      <div className="">
        <div className="flex flex-wrap items-center justify-center !gap-y-3 medium:!gap-x-4 medium:!gap-y-4 p-4 medium:py-3 medium:!px-[52px]  large:!px-[52px]">
          {displayData.map((item, index: number) => (
            <div
              key={item.id}
              className={getClassNames(index, displayData.length)}
              style={{ flex: '1 1 0%' }}
            >
              <p className="text-[20px] font-inter font-bold leading-[30px] medium:!font-nunito medium:text-[18px] medium:leading-[26px] text-gray-900 medium:text-gray-850 text-center text-ellipsis line-clamp-1">
                {item.value?.trim().length > 20
                  ? `${item.value?.trim().slice(0, 17)}...`
                  : item.value?.trim()}
              </p>
              <p className="text-[14px] font-normal leading-[22px] font-nunito medium:text-[18px] medium:leading-[26px] text-gray-650 medium:!text-gray-850 text-center text-ellipsis line-clamp-1">
                {item.key?.trim().length > 30
                  ? `${item.key?.trim().slice(0, 27)}...`
                  : item.key?.trim()}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetaDataStrip;
